import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Box, FormButtonStyled, HeadingStyled, SpanStyled, TextStyled } from "../../../../components/styled/Elements";
import OTPInputField from "../../../../components/common/inputFields/OTPInputField";

const PhoneSignin2 = ({ handleSteps, handleSendOtp }) => {
  const otpFieldRef = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);

  const handleResendOtp = () => {
    handleSendOtp(otpFieldRef);
    // otpFieldRef.current?.resetTimer();
  };

  const verifyOtp = async (num, accessToken) => {
    const formData = new FormData();
    formData.append("phone_number", num);
    formData.append("verification", accessToken);
    
  };

  const onSubmit = async (data) => {
    const otp = Object.values(data).join("");
    
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Box className="mb-4 ">
        <HeadingStyled size="24px" weight="bold" color="var(--text)">
          {t("we_just_texted_you")}
        </HeadingStyled>
        <TextStyled size="16px" color="var(--text2)">
          {t("enter_the_code_we_sent_you")} +966987654321
        </TextStyled>
        <HeadingStyled size="14px" weight="500" color="var(--text)">
          {t("OTP")}
        </HeadingStyled>
      </Box>
      <Box>
        <Box>
          <OTPInputField
            ref={otpFieldRef}
            register={register}
            setValue={setValue}
          />
          <FormButtonStyled
            label={t("sign_in")}
            color="var(--white)"
            bg="var(--themeColor)"
            className="w-100"
            clName="w-100 my-4"
            type="submit"
            isLoading={loading}
          />
        </Box>
        <Box className="d-flex justify-content-center">
          <Box>
            <TextStyled color="var(--text2  )" size="16px" weight="500">
              {t("did_not_receive_otp")}
              &emsp;
              <SpanStyled
                className="cursor-pointer"
                color="var(--themeColor)"
                size="16px"
                weight="700"
                onClick={handleResendOtp}
              >
                {t("resend")}
              </SpanStyled>
            </TextStyled>
          </Box>
        </Box>
      </Box>
    </Form>
  );
};

export default PhoneSignin2;
